import React from 'react';
import { Box } from '@chakra-ui/react';
import { Group, Panel, Separator, useDefaultLayout } from 'react-resizable-panels';

const GROUP_ID = 'vorakit-browse-player-split';
const PANEL_BROWSE = 'browse-main';
const PANEL_PLAYER = 'player-column';

type Props = {
  browseColumn: React.ReactNode;
  playerColumn: React.ReactNode;
};

/** Horizontal split: channels/browse | player / detail — sizes persist in localStorage. */
export function ResizableBrowsePlayerSplit({ browseColumn, playerColumn }: Props) {
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    id: GROUP_ID,
    panelIds: [PANEL_BROWSE, PANEL_PLAYER],
    storage: localStorage,
  });

  return (
    <Group
      id={GROUP_ID}
      defaultLayout={defaultLayout}
      onLayoutChanged={onLayoutChanged}
      style={{ flex: 1, minHeight: 0, minWidth: 0, overflow: 'hidden', width: '100%' }}
    >
      <Panel id={PANEL_BROWSE} defaultSize="64%" minSize="38%" maxSize="82%">
        <Box h="100%" minH={0} minW={0} overflow="hidden" display="flex" flexDirection="column">
          {browseColumn}
        </Box>
      </Panel>
      <Separator
        style={{
          width: 8,
          minWidth: 8,
          background: 'rgba(255, 255, 255, 0.06)',
        }}
      />
      <Panel id={PANEL_PLAYER} defaultSize="36%" minSize="22%" maxSize="58%">
        <Box h="100%" minH={0} minW={0} overflow="hidden">
          {playerColumn}
        </Box>
      </Panel>
    </Group>
  );
}
